// extracted by css-extract-rspack-plugin
export default {"propertiesListContainer":"RepoPropertiesList-module__propertiesListContainer__gpCPF"};